import React from "react";
import "./SupportInfo.css";

export const SupportInfo = () => (
  <div className="container-support-info">
    <div className="support">
      <p className="support_desc">
        Need help? Please send any feedback or bug reports via{" "}
        <a
          className="support_email"
          href="mailto:athena.helpdesk@cheil.com"
        >
          email
        </a>
      </p>
    </div>
  </div>
);
